require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-65-changing-the-status-of-a-project.json") })
        }
      }, "path---article-65-changing-the-status-of-a-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-65-changing-the-status-of-a-project!./.cache/json/article-65-changing-the-status-of-a-project.json
// module id = 561
// module chunks = 231608221292675